import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Paho } from 'ng2-mqtt/mqttws31';
import { ConfigService } from './config.service';
import * as myGlobals from './globals';

@Injectable()

export class MqttService {

  private client: Paho.MQTT.Client;
  private missionAnnouncedSource = new Subject<string>();
  private appconfigSource = new Subject<string>();
  missionAnnounced$ = this.missionAnnouncedSource.asObservable();
  appconfig$ = this.appconfigSource.asObservable();

  announceMission(data: string) {
    this.missionAnnouncedSource.next(data);
    console.log("mqtt data--------------->", data);
  }

  constructor(private _cookie: ConfigService) {
    this.client = new Paho.MQTT.Client(myGlobals.mqtt_channel, "myClientId" + new Date().getTime());

    // Gets Called if the connection has successfully been established
    let onSuccess = () => {
      console.log('connected');
      this.client.subscribe(this._cookie.getItem('mqttTopic'), { qos: 2 });
      // this.client.subscribe('godsview/location', { qos: 2 });
      console.log('mqtt channel---->', this._cookie.getItem('mqttTopic'), { qos: 2 });
    }
    let onFailure = (message) => {
      alert("failru");
      console.log('Connection failed:.' + message.errorMessage);
    }

    const options = {
      userName: myGlobals.mqtt_username,
      password: myGlobals.mqtt_password,
      useSSL: true,
      timeout: 60,
      keepAliveInterval: 15,

      onSuccess: onSuccess,
      onFailure: onFailure,

      // // Gets Called if the connection has successfully been established
      // onSuccess: () => {
      //   console.log('connected');
      //   this.client.subscribe(this._cookie.getItem('mqttTopic'), { qos: 2 });
      //   // this.client.subscribe('godsview/location', { qos: 2 });
      //   console.log('mqtt channel---->', this._cookie.getItem('mqttTopic'), { qos: 2 });
      // },
      // Gets Called if the connection could not be established
      // onFailure: function (message) {
      //   alert("failru");
      //   console.log('Connection failed:.' + message.errorMessage);
      // }
    };
    this.client.connect(options);

    this.client.onConnectionLost = (responseObject: Object) => {
      console.log('Connection lost.', responseObject);
      const options = {
        userName: myGlobals.mqtt_username,
        password: myGlobals.mqtt_password,
        useSSL: true,
        timeout: 60,
        keepAliveInterval: 15,

        onSuccess: onSuccess,
        onFailure: onFailure,
      };
      this.client.connect(options);
    };

    this.client.onMessageArrived = (message: Paho.MQTT.Message) => {
      console.log('Message arrived.', message);
      console.log(message.payloadString);
      console.log(JSON.parse(message.payloadString));
      this.missionAnnouncedSource.next(JSON.parse(message.payloadString));
    };
  }
}


// WEBPACK FOOTER //
// F:/Karry/Zoom/ZoomCustomer/src/app/mqtt.service.ts